<div class="shop-cart">
	<div class="row shop-cart-item-headline show-for-medium">
		<div class="column medium-6">
			<div class="row">
				<div class="column small-3 large-4"></div>
				<div class="column small-9 large-8">{{'shop.cart.items.product' | translate}}</div>
			</div>
		</div>
		<div class="column small-12 medium-6">
			<div class="row">
				<div class="column small-12 medium-6 large-3 align-center">{{'shop.cart.items.count' | translate}}</div>
				<div class="column small-12 medium-6 large-3 align-right">{{'shop.cart.items.price' | translate}}</div>
				<div class="column small-12 large-3 show-for-large align-right" *ngIf="giftCount > 0">{{'shop.cart.items.gifts' | translate}}</div>
				<div class="column small-12 large-3 show-for-large end align-right">{{'shop.cart.items.sum' | translate}}</div>
			</div>
		</div>
		<div class="column medium-12"><hr></div>
	</div>

	<div class="shop-cart-items">
		<div class="row shop-cart-item" *ngFor="let item of items">
			<!-- image + description -->
			<div class="column small-12 medium-6">
				<div class="row">
					<div class="column small-3 large-4">
						<img *ngIf="item.product.images.length > 0" [src]="getProuctImage(item.product)" [alt]="item.product.name">
					</div>
					<div class="column small-9 large-8">
						<h2 [innerHTML]="item.product.name"></h2>
						<span class="textinput" *ngIf="item.text">{{'shop.item.textinput.placeholder' | translate}}: {{item.text}}</span>
						<a (click)="removeItem(item)" tabindex="0" (keydown.space)="removeItem(item)">{{'shop.cart.item.remove' | translate}}</a>
					</div>
				</div>
			</div>

			<div class="column small-12 medium-6">
				<div class="row">
					<!-- cart change -->
					<div class="column small-12 medium-6 large-3">
						<div class="row collapse cart-change" *ngIf="(item.freePrice === null && item.text === null) || item.forceCountModifiable">
							<shop-amount-select [maxAmount]="inventory[item.uuid].available + item.count" [itemCount]="item.count" [itemName]="item.product.name" (amountChange)="changeItemCount($event, item)"></shop-amount-select>
						</div>

						<div class="row column price-value text-center" *ngIf="(item.freePrice !== null || item.text !== null) && !item.forceCountModifiable">{{ item.count }}</div>
						<p class="amount-info fade-in" *ngIf="inventory[item.uuid].available === 0">
							{{ 'shop.info.product.max' | translate : {max: item.product.getMaxCount()} }}
						</p>
					</div>

					<!-- single price -->
					<div class="column small-12 medium-6 large-3 price-value align-right">
						<span class="hide-for-medium">{{'shop.cart.items.price' | translate}}: </span>{{item.getPrice() | number: priceFormat}} {{donation.currencySymbol}}
					</div>

					<!-- gifts -->
					<div class="column small-12 large-3 price-value align-right" *ngIf="giftCount > 0">
						<span class="hide-for-large">{{'shop.cart.items.gifts' | translate}}: </span>
						x {{giftCount}}
					</div>

					<!-- sum -->
					<div class="column small-12 large-3 price-value align-right end">
						<span class="hide-for-large">{{'shop.cart.items.sum' | translate}}: </span><strong>{{(item.getPrice() * item.count * (giftCount > 1? giftCount : 1)) | number: priceFormat}} {{donation.currencySymbol}}</strong>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="shop-cart-sum">
		<div class="row">
			<div class="column small-12">
				<span class="shop-sum-label" [class.has-gift]="giftCount > 0" [innerHTML]="'shop.cart.sum' | translate"></span>
				<span class="shop-sum-total"> {{overallPrice | number: priceFormat}} {{donation.currencySymbol}}</span>
			</div>
		</div>
	</div>

	<div class="row column shop-download" *ngIf="hasOptionalDonation()">
		<h2>{{ 'shop.brochure.donation.cart' | translate }}</h2>
		<amount [donation]="optionalDonation" [form]="form" [minAmount]="0"></amount>
	</div>	
	<amount-extra [donation]="donation" [form]="form" [useCart]="true" [amount]="optionalDonation?.amount"></amount-extra>

	<gift-donation *ngIf="showGiftDonation" [form]="form" [donation]="donation" [overlayName]="'shopgift'" [products]="productsForGift" (formChanged)="onFormChanged($event)" (receiverCountChanged)="updateGiftCount($event)" [updateValueForPreview]="overallPrice"></gift-donation>	

	<div class="row column button-wrapper">
		<button class="button arrow arrow-right" [class.grey]="!formValid" (click)="nextStep()">{{(contactMandatory? 'widget.start.button' : 'shop.cart.button') | translate}}</button>
	</div>
</div>
